import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import {
  PieChart,
  Pie,
  Tooltip,
  Legend,
  Cell,
  ResponsiveContainer
} from 'recharts';

const StatsModal = ({
  show,
  onHide,
  totalNumbers,
  totalCampaignList,
  callsDialed,
  pendingCalls,
  dndCount,
  connectedCalls,
  totalCallsDialed,
  retryCount,
  totalReady
}) => {

  const data = [
    { name: 'Total Numbers', value: totalNumbers, color: '#007bff' },
    { name: 'Total Campaign', value: totalCampaignList, color: '#17a2b8' },
    { name: 'Total Calls Dialed', value: totalCallsDialed, color: '#fd7e14' },
    { name: 'Dialed', value: callsDialed, color: '#ffc107' },
    { name: 'Retry Count', value: retryCount, color: '#6610f2' },
    { name: 'Pending', value: pendingCalls, color: '#6f42c1' },
    { name: 'DnD', value: dndCount, color: '#dc3545' },
    { name: 'Connected', value: connectedCalls, color: '#28a745' },
    { name: 'Total Ready', value: totalReady, color: '#d32ac2' },
  ];

  const allZero = data.every(item => Number(item.value) === 0);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Campaign Overview</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {allZero ? (
          <div className="text-center py-5" style={{ fontSize: '18px', fontWeight: '600' }}>
            No data available to display.
          </div>
        ) : (
          <div style={{ width: '100%', height: '350px' }}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  dataKey="value"
                  data={data}
                  cx="50%"
                  cy="50%"
                  outerRadius="80%"
                  label
                  minAngle={1}
                >
                  {data.map((entry, index) => (
                    <Cell key={index} fill={entry.color} />
                  ))}
                </Pie>

                <Tooltip formatter={(v) => v.toLocaleString()} />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        )}

      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StatsModal;
